import styled from '@emotion/styled';
import {colors} from '../../../styles';

export const ErrorText = styled.span`
  color: ${({theme}) => theme?.colors.destructive.main};
`;

export const SelectLabel = styled.div<{hasError: boolean}>`
  margin-bottom: 8px;

  > label {
    font: ${({theme}) => theme?.fonts?.label};
    color: ${({hasError}) => (hasError ? colors.red : 'inherit')};
  }
`;
